// Customer account self-service. Profile endpoints are scoped by bearer token.
import { apiClient, endpoints, unwrap } from '@core/api';

/** Account-level info (account-wide settings, payment options, etc.) */
export async function getAccountInfo() {
  const raw = await apiClient.get(endpoints.account.info);
  const { data } = unwrap(raw);
  return data ?? raw;
}

/** Customer profile (read). */
export async function getProfile() {
  const raw = await apiClient.get(endpoints.account.profile);
  const { data } = unwrap(raw);
  return data ?? raw;
}

/** Customer profile (update). */
export async function updateProfile(input) {
  return apiClient.patch(endpoints.account.profile, { data: input });
}

/** Change the signed-in customer's password. */
export async function changePassword({ currentPassword, newPassword, confirmPassword }) {
  return apiClient.post(endpoints.account.changePassword, {
    data: {
      old_password: currentPassword,
      new_password: newPassword,
      confirm_password: confirmPassword ?? newPassword,
    },
  });
}
export async function deleteAccount() {
  return apiClient.delete(endpoints.account.profile);
}
